import { render, staticRenderFns } from "./PrestamosPersonales.vue?vue&type=template&id=2fb9fd06"
import script from "./PrestamosPersonales.vue?vue&type=script&lang=js"
export * from "./PrestamosPersonales.vue?vue&type=script&lang=js"
import style0 from "./PrestamosPersonales.vue?vue&type=style&index=0&id=2fb9fd06&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports